export default __webpack_public_path__ + "static/media/tissue.1c5cc6f8.gif";